import { Component, Input } from '@angular/core';
import { getClientAssociationType } from '@core/util/client';
import {
	ActingForType,
	MatterClientRelationship,
	MatterFileType,
} from '@models/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterClientDispatch } from '@state/matter_clients/matterClients.dispatch';
import { ICON } from '@core/util/icon';
import {
	BusinessClient,
	ClientCreationData,
	PersonClient,
} from '@models/clients';

import LogRocket from 'logrocket';
import { SearchType } from 'src/app/public/leap/leap-api.service';
import { TestHooks } from './party-clients-header.hooks';

type ClientTypes = BusinessClient | PersonClient;

@Component({
	selector: 'app-party-clients-header',
	templateUrl: './party-clients-header.component.html',
	standalone: false,
})
export class PartyClientsHeaderComponent {
	testHooks = TestHooks;
	public showAddClient = false;
	public ICON = ICON;

	@SelectSnapshot(SelectedMatter.actingFor) actingFor: ActingForType;
	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@Input() primaryContact = false;
	@Input() isClient: boolean;
	@Input() matterFileType: MatterFileType;
	@Input() addButtonText: string;
	@Input() placeholder: string = 'Search Client';
	@Input() createButtonLabel: string;
	@Input() contactTypeLabel: string;

	constructor(private matterClientDispatch: MatterClientDispatch) {}

	public SearchType = SearchType;

	toggleAddClient(): void {
		this.showAddClient = !this.showAddClient;
	}

	onDelayFinished(): void {
		this.showAddClient = false;
	}

	addClient($event: ClientCreationData): void {
		this.matterClientDispatch.CreateAndAddClientToMatter({
			client: $event.client,
			matterClientRelationship: {
				...$event.matterClientRelationship,
				clientTypes: [
					getClientAssociationType(this.isClient, this.matterFileType),
				],
				client: this.isClient,
				primaryContact: this.primaryContact,
			},
		});
	}

	onClientSelected(client: ClientTypes): void {
		if (client == null) return;

		if (client.isLeap) {
			LogRocket.info('Adding a LEAP client with ID:', client.id);
			this._addLeapClient(client);
		} else {
			LogRocket.info('Adding a client with ID:', client.id);
			this._addClient(client.id);
		}
	}

	_addLeapClient(client: ClientTypes): void {
		const clientType = getClientAssociationType(
			this.isClient,
			this.matterFileType,
		);

		this.matterClientDispatch.CreateAndAddClientToMatter({
			client: client,
			matterClientRelationship: {
				id: client.id,
				clientTypes: [clientType],
				client: this.isClient,
				primaryContact: this.primaryContact,
			},
		});
	}

	_addClient(clientId: string): void {
		const clientType = getClientAssociationType(
			this.isClient,
			this.matterFileType,
		);
		const clientRelationship: MatterClientRelationship = {
			id: clientId,
			clientTypes: [clientType],
			primaryContact: this.primaryContact,
			client: this.isClient,
		};
		this.matterClientDispatch.AddClient(clientRelationship);
	}
}
